import { Direction, sortItemsByProperty } from '~shared/utils/sort';
import {
  NormalizedResponse,
  combineQuestionIdStudentId,
} from '~teacher/components/ActivityResult/util/normalizeResponses';
import { StudentActivityResponse } from '~teacher/models/activities';
export function findResponse({
  responses,
  questionId,
  studentId,
}: {
  responses: NormalizedResponse;
  questionId: number;
  studentId: number;
}) {
  if (!questionId || !studentId || !responses) {
    if (__DEV__) {
      console.debug(
        `Either questionId, studentId, or responses is null. Questionid ${questionId} studentId: ${studentId} responses: ${responses}`
      );
    }
    return undefined;
  }
  const key = combineQuestionIdStudentId({ studentId, questionId });

  const ids = responses.byQuestionStudentId[key];
  if (!ids) {
    return undefined;
  }
  const allResponses = sortItemsByProperty({
    items: ids.map<StudentActivityResponse>((id) => responses.entities[id]),
    property: 'id',
    sortDirection: Direction.Descending,
  });
  return allResponses[0];
}
